<template>
    <transition name="fade">
        <div id="objection">
            <h1>Voulez-vous poser l’objection suivante : </h1>
            <h1>“La surveillance de mes patients avec ce traitement me semble contraignante...”</h1>
            <div id="decisions">
                <button @mouseover="afterLeft" @click="emitGoPlan" @mouseleave="afterLeft">Oui</button>
                <div id="toggle"></div>
                <button @mouseover="afterRight" @mouseleave="afterRight">Non</button>
            </div>
        </div>
    </transition>
</template>
<script>
    export default {
        name: 'Objection',
        methods: {
            afterRight() {
                $("#toggle").toggleClass("no")
            },
            afterLeft() {
                $("#toggle").toggleClass("yes")
            },
            emitGoPlan() {
                this.$emit('go')
            }
        }
    }
</script>

<style lang="scss" scoped>

    #objection {
        position: absolute;
        height: 80%;
        top: 10%;
        left: 10%;
        background-color: rgba(0, 0, 0, 0.51);
        color: #fff;
        width: 80%;
        padding: 30px 50px;
        box-sizing: border-box;
        padding: 3% 5%;
        z-index: 4;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-content: center;
        h1 {
            text-align: center;
            font-size: 2vw;
            margin-top: 5%;
            font-weight: normal;
        }
        #decisions {
            margin-top: 5%;
            display: flex;
            justify-content: center;
            button {
                border: none;
                background-color: transparent;
                color: #fff;
                margin: 20px;
                border-radius: 50px;
                font-size: 3rem;
                font-weight: bold;
                transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
                cursor: pointer;
                outline: none;
                position: relative;
                transition: 2s;
                &:hover {
                    &:after {
                        opacity: 1;
                        bottom: 0px;
                    }
                }
                /*&:active {*/
                /*&:before {*/
                /*opacity: 1;*/
                /*transform: scale(1, 1);*/
                /*}*/
                /*}*/
                /*&:before {*/
                /*transition: 2s;*/
                /*content: "";*/
                /*!*opacity: 0;*!*/
                /*!*transform: scale(0,0);*!*/
                /*background-color: red;*/
                /*position: absolute;*/
                /*left: 50%;*/
                /*top: 50%;*/
                /*width: 50%;*/
                /*height: 50%;*/
                /*}*/
                &:after {
                    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
                    content: "";
                    opacity: 0;
                    width: 100%;
                    position: absolute;
                    height: 3px;
                    background-color: #fff;
                    bottom: -25px;
                    left: 0;
                }
            }
            #toggle {
                min-width: 25%;

                position: relative;
                &.no {
                    &:after {
                        left: 90%;
                    }
                }
                &.yes {
                    &:after {
                        left: 0%;
                    }
                }
                &:after {
                    content: "";
                    border-radius: 100%;
                    transition: 500ms;
                    padding: 20px;
                    top: 30%;
                    left: 45%;
                    background-color: #2235a1;
                    position: absolute;
                }
                &:before {
                    position: absolute;
                    content: "";
                    height: 2px;
                    width: 100%;
                    border-radius: 3px;
                    top: 50%;
                    background-color: #fff;
                }
            }
        }
    }


</style>